import es from './lang/es.json';

export default es.translation;
